import React from "react";

import HekmaLogo from "../../../../img/Hekmalogo.svg";

const DefaultAvatar = ({ size = "100px", height }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: size,
        height: height ? height : size,
        background: "white",
        padding: "15px",
        borderRadius: "40px",
        margin: "auto"
      }}
    >
      <div
        style={{
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          backgroundColor: "#ccc",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "24px",
          color: "#fff",
          fontWeight: "bold",
        }}
      >
        <img src={HekmaLogo} about="Hekma" alt="Hekma Logo" style={{ width: "100px", height: "100px" }} />
      </div>
    </div>
  );
};

export default DefaultAvatar;
